// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__SfISU","success":"Notification_success__5+j+a","failed":"Notification_failed__0+WLd"};